import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

import { Box, Tabs } from '@mui/material';
import { StyledPanel, StyledTab, StyledTitle } from 'src/Esg/styles';
import {
  useEsgDmaActions,
  useEsgStakeholdersAnswersAnalytics,
} from '../../hooks';
import { useEsgReports } from 'src/Esg/hooks';
import ExportToCsvButton from '../../components/DmaExportButton';

const TABS = ['dashboard', 'individual'];
// , 'table', 'subtopic', 'individual'];

export default function DmaStakeholderAnalyticsV2() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const tab = location.pathname.split('/').pop();
  const { reportId } = useParams();
  const { _instance: report } = useEsgReports({ id: Number(reportId) });

  const { analytics } = useEsgStakeholdersAnswersAnalytics(report?.esg_dma_id);
  const { responses_count: dataCount = 0 } = analytics;

  const { exportStakeholderAnswersToCsv } = useEsgDmaActions(
    report?.esg_dma_id
  );

  const handleTabChange = (_: any, _tab: string) =>
    navigate(`../v2/stakeholders/analytics/${_tab}`);

  let title;

  if (dataCount === 1) {
    title = t('esg:dma.stakeholderAnalytics.title', {
      count: dataCount,
    });
  } else {
    title = t('esg:dma.stakeholderAnalytics.title_plural', {
      count: dataCount,
    });
  }

  return (
    <>
      <StyledPanel sx={{ p: '30x', pb: 0, mt: '20px' }}>
        <Box display="flex" justifyContent="space-between">
          <StyledTitle>{title}</StyledTitle>
          <ExportToCsvButton
            handleExportToCsv={() => exportStakeholderAnswersToCsv.mutate({})}
          />
        </Box>
        <br />
        <Tabs variant="fullWidth" value={tab} onChange={handleTabChange}>
          {TABS.map((_tab: string) => (
            <StyledTab
              key={_tab}
              label={t(`esg:dma.stakeholderAnalytics.tabs.${_tab}`)}
              id={_tab}
              value={_tab}
            />
          ))}
        </Tabs>
      </StyledPanel>
      <br />
      <Outlet />
    </>
  );
}
